var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9531 3.55957C11.2931 3.55957 3.45312 11.3996 3.45312 21.0596C3.45312 30.7196 11.2931 38.5596 20.9531 38.5596C30.6131 38.5596 38.4531 30.7196 38.4531 21.0596C38.4531 11.3996 30.6306 3.55957 20.9531 3.55957Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2249 19.7354L18.8272 14.3927C17.5046 13.4374 15.6562 14.3825 15.6562 16.014V26.6995C15.6562 28.331 17.5046 29.2761 18.8272 28.3209L26.2249 22.9781C27.3302 22.1798 27.3302 20.5337 26.2249 19.7354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.145803ff3f3007f872c597a0c578cff1.svg";
export { ForwardRef as ReactComponent };